import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
import Vue from "vue";
import store from "@/store/store";
import router from "@/route/index";

const CryptoJS = require("crypto-js");

// /*===================生成签名======================*/
// var str = operatorId + afterAES.toString() + timeStamp + seq;
// console.log("签名str：" + str);
// var xstrmd5 = CryptoJS.HmacMD5(str, sign_key).toString().toUpperCase();
// console.log("签名：" + xstrmd5);
/*===================生成签名======================*/

//验证签名
const check_sign = function (str, key, sign) {
    let new_sign = CryptoJS.HmacMD5(str, key).toString().toUpperCase();
    return sign === new_sign
}
//生成时间戳
const get_time_stamp = function () {
    let d = new Date();
// 将月份格式化为2位
    let month = (d.getMonth() + 1).toString();
    if (month.length === 1) {
        month = "0" + month;
    }
//将日期格式化为2位
    let timeDate = d.getDate().toString();
    if (timeDate.length === 1) {
        timeDate = "0" + timeDate;
    }
//将小时格式化为2位
    let timeHour = (d.getHours()).toString();
    if (timeHour.length === 1) {
        timeHour = "0" + timeHour;
    }
//将分钟组格式化为2位
    let timeMin = d.getMinutes().toString();
    if (timeMin.length === 1) {
        timeMin = "0" + timeMin;
    }
//将秒格式化为2位
    let timeSec = d.getSeconds().toString();
    if (timeSec.length === 1) {
        timeSec = "0" + timeSec;
    }
//整理时间格式
    return d.getFullYear() + '-' + month + '-' + timeDate + ' ' + timeHour + ':' + timeMin + ':'
        + timeSec
}
//递归验证必填项
const r_obj = function (data) {
    let check_list = []
    let error_list = []
    // console.log(data,'y67')
    for (let i in data) {
        if (data[i].son_list.length > 0) {
            let list = r_obj(data[i].son_list, check_list, error_list)
            check_list.push.apply(check_list, list[0])
            error_list.push.apply(error_list, list[1])
        } else {
            if (data[i].c_level === 3) {
                let id = data[i].c_code
                let value = data[i].c_value
                let func = data[i].c_func
                if (data[i].c_priority === 'S' && (value === null || value === '')) {
                    error_list.push(data[i].c_name)
                }
                if (value !== null) {
                    check_list.push({'id': id, 'value': value, 'func': func})
                }
            }
        }
    }
    return [check_list, error_list]
}
//AES加密
const encryption = function (data, data_secret, data_secret_iv) {
    let str = JSON.stringify(data)
    let srcs = CryptoJS.enc.Utf8.parse(str);
    let key = CryptoJS.enc.Utf8.parse(data_secret);
    let iv = CryptoJS.enc.Utf8.parse(data_secret_iv);
    let afterAES = CryptoJS.AES.encrypt(srcs, key, {iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7});
    return afterAES.toString();
};
//AES解密
const decryption = function (str, key, iv) {
    let r = CryptoJS.enc.Utf8.parse(iv)
    let n = CryptoJS.enc.Utf8.parse(key)
    let o = CryptoJS.AES.decrypt(str, n, {
        iv: r,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    let end = CryptoJS.enc.Utf8.stringify(o).toString()
    return JSON.parse(end)
};
//验证必填项
const check_data = function (attr_list, obj_list, list_name = null) {
    let error_list = []
    let list = attr_list
    for (let x in list) {
        for (let i in list[x]) {
            if (list_name == null) {
                if (list[x][i].c_priority === 'S' && list[x][i].c_data_type !== 'Static') {
                    if (list[x][i].c_value === null || list[x][i].c_value === ''
                        || list[x][i].c_value.length === 0 || list[x][i].c_value === {}) {
                        error_list.push(list[x][i].c_name)
                    }
                }
            } else {
                for (let z in list[x][i][list_name]) {
                    if (list[x][i][list_name][z].c_priority === 'S' && list[x][i][list_name][z].c_data_type !== 'Static') {
                        if (list[x][i][list_name][z].c_value === null || list[x][i][list_name][z].c_value === '' || list[x][i][list_name][z].c_value.length === 0 || list[x][i][list_name][z].c_value === {}) {
                            error_list.push(list[x][i][list_name][z].c_name)
                        }
                    }
                }
            }
        }
    }
    let objs = obj_list
    for (let x in objs) {
        if (objs[x].value === null || objs[x].value === {} || objs[x].value === '' || objs[x].value === undefined) {
            error_list.push(objs[x].name)
        }
    }
    if (error_list.length !== 0) {
        Vue.prototype.$message({
            message: '请填写全部必填项:' + error_list.join(','),
            type: 'error',

        });
        return false
    }
    return true
};
//删除前提示
const confirm_delete = function (title, confirm_func, confirm_data, cancel_func, cancel_data) {
    const methods = this.$options.methods
    Vue.prototype.$confirm(title, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
    }).then(() => {
        if (confirm_func) {
            if (confirm_data) {
                methods[confirm_func].call(this, confirm_data)
            } else methods[confirm_func].call(this, null)
        }
    }).catch(() => {
        if (cancel_func) {
            if (cancel_data) {
                methods[cancel_func].call(this, cancel_data)
            } else methods[cancel_func].call(this, null)
        }
    });
};
//验证权限
const check_auth = function (auth) {
    for (let i in store.state.check_auth_list) {
        if (store.state.check_auth_list[i] === auth) {
            return true
        }
    }
    return false
};
//打印页面
//对象元素添加id="pdfDom"
const getPdf = function (title) {
    // let title = this.htmlTitle  //DPF标题
    html2Canvas(document.querySelector('#pdfDom'), {
        allowTaint: true,
        taintTest: false,
        useCORS: true,
        dpi: window.devicePixelRatio * 4, //将分辨率提高到特定的DPI 提高四倍
        scale: 4 //按比例增加分辨率
    }).then(function (canvas) {
            let contentWidth = canvas.width
            let contentHeight = canvas.height
            let pageHeight = contentWidth / 592.28 * 841.89
            let leftHeight = contentHeight
            let position = 0
            let imgWidth = 595.28
            let imgHeight = 592.28 / contentWidth * contentHeight
            let pageData = canvas.toDataURL('image/jpeg', 1.0)
            let PDF = new JsPDF('', 'pt', 'a4')
            if (leftHeight < pageHeight) {
                PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
            } else {
                while (leftHeight > 0) {
                    PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
                    leftHeight -= pageHeight
                    position -= 841.89
                    if (leftHeight > 0) {
                        PDF.addPage()
                    }
                }
            }
            PDF.save(title + '.pdf')
            return true
        }
    )
};
//验证树结构必填项
const analyze_attr_tree = function (attr_tree) {
    console.log(attr_tree, 'attr')
    let list = r_obj(attr_tree)
    let check_list = list[0]
    let error_list = list[1]
    if (error_list.length !== 0) {
        Vue.prototype.$message({
            message: '请填写全部必填项:' + error_list.join(','),
            type: 'error'
        });
        return null
    } else return check_list
};
// 验证功能模块
const check_func = function (name, flag = false) {
    if (store.state.func_list === null) {
        if (flag === true) {
            Vue.prototype.$message({
                message: '登录信息过期，请重新登录',
                type: 'warning'
            });
        }
        router.push('/')
        return false
    }
    if (store.state.func_list !== undefined && store.state.func_list.indexOf(name) !== -1) {
        return true
    } else {
        if (flag === true) {
            Vue.prototype.$message({
                message: '用户该功能尚未启用或已到期，请充值或联系管理员。',
                type: 'warning'
            });
        }
        return false
    }
};
//返回前一栈
const go_back = function () {
    router.back()
};
const install = function (Vue) {
    Vue.prototype.$encryption = encryption
    Vue.prototype.$decryption = decryption
    Vue.prototype.$check_data = check_data
    Vue.prototype.$confirm_delete = confirm_delete
    Vue.prototype.$check_auth = check_auth
    Vue.prototype.$getPdf = getPdf
    Vue.prototype.$analyze_attr_tree = analyze_attr_tree
    Vue.prototype.$get_time_stamp = get_time_stamp
    Vue.prototype.$check_sign = check_sign
    Vue.prototype.$check_func = check_func
    Vue.prototype.$go_back = go_back
}
export default {
    install
}